import { getApiClient, initializeApiClient } from "../../apiService";

export const UpdateOtherProjectSupport = async (
  tE_OS_OtherSupportingOrganizationsId,
  organizationName,
  tE_OS_NatureOfSupportId,
  supportDetails,
  supportAmountIfMonetary,
  tE_TeamMembersPreviousExperiencePartnershipsId
) => {
  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post(
    `/api/TE_OS_OtherSupportingOrganizations/UpdateTE_OS_OtherSupportingOrganizationsData`,
    {
      tE_OS_OtherSupportingOrganizationsId:
        tE_OS_OtherSupportingOrganizationsId,
      organizationName: organizationName,
      tE_OS_NatureOfSupportId: tE_OS_NatureOfSupportId,
      supportDetails: supportDetails,
      supportAmountIfMonetary: supportAmountIfMonetary,
      tE_TeamMembersPreviousExperiencePartnershipsId:
        tE_TeamMembersPreviousExperiencePartnershipsId,
    }
  );

  return response;
};

export default UpdateOtherProjectSupport;
